"use client";

import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const bundles = [{
  id: 1,
  title: "Hong Kong Gateway",
  description: "Leveraging the world's most efficient deep-water port to ensure seamless regional trade and export coordination across the Far East.",
  link: "https://trusting-sunbird.10web.cloud/markets/"
}, {
  id: 2,
  title: "Industrial Logistics",
  description: "Grounded supply chain operations specializing in the secure transport and storage of industrial oils and biofuel feedstocks.",
  link: "/Products"
}, {
  id: 3,
  title: "Regional Trade Hub",
  description: "Strategic positioning in East Asia providing a reliable bridge between global producers and regional industrial consumers.",
  link: "/AboutUsPage"
}];
const bundleImages = [{
  bundleId: 1,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/hong_kong_port_main.png",
  span: "col-span-2 row-span-2"
}, {
  bundleId: 1,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/cargo_ship_detail_1.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 1,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/container_stack_detail_2.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 1,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/maritime_logistics_detail_3.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 1,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/port_crane_detail_4.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 2,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/industrial_oil_storage_main.png",
  span: "col-span-2 row-span-2"
}, {
  bundleId: 2,
  url: "https://trusting-sunbird.10web.cloud/wp-content/uploads/2026/05/renewable_aviation_fuel.png?v=xh4szscx5ba",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 2,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/tanker_truck_detail_2.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 2,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/pipeline_infrastructure_detail_3.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 2,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/quality_control_detail_4.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 3,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/far_east_shipping_main.png",
  span: "col-span-2 row-span-2"
}, {
  bundleId: 3,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/southeast_asia_trade_detail_1.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 3,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/vessel_navigation_detail_2.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 3,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/commodity_trading_detail_3.png",
  span: "col-span-1 row-span-1"
}, {
  bundleId: 3,
  url: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/export_coordination_detail_4.png",
  span: "col-span-1 row-span-1"
}];
export default function CuratedForStorytellers() {
  return;
}